import React, { PureComponent, Fragment } from "react";
import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Line,
} from "recharts";
import {
  Metric,
  selectFormat,
  Error,
  StandardTooltip,
  CustomizedYAxisTick,
} from "./../Utils/Utils.js";
import Heading from "./../Elements/Heading";

class FreeTrialConversionPrediction extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  render() {
    const { data } = this.props;
    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }
    return (
      <div className="row mt-2 d-flex align-items-end">
        {/* Header */}
        <div className="col-12 widget__info-text">
          <h5>
            <span>Predicted Conversion</span>{" "}
            <span className="text-gray">vs</span>{" "}
            <span className="text-orange">Free Trial Ending</span>
          </h5>
        </div>

        {/* Expected/today metric */}
        <div className="col-6 col-md-6">
          <Heading size={6} className={"mb-1"}>
            Expected Today
          </Heading>
          <div className="d-inline-block">
            <Metric
              {...{ value: data.expected_today.lower_bound }}
              size={"md"}
            />
          </div>
          <div className="d-inline-block">
            <div className="metric metric--md">
              <span className="metric__primary"> - </span>
            </div>
          </div>
          <div className="d-inline-block">
            <Metric
              {...{ value: data.expected_today.upper_bound }}
              size={"md"}
            />
          </div>
        </div>

        {/* Expected/next metric  */}
        <div className="col-6 col-md-6">
          <Heading size={6} className={"mb-1"}>
            Expected Next 7 Days
          </Heading>
          <div className="d-inline-block">
            <Metric
              {...{ value: data.expected_next_7_days.lower_bound }}
              size={"md"}
            />
          </div>
          <div className="d-inline-block">
            <div className="metric metric--md">
              <span className="metric__primary"> - </span>
            </div>
          </div>
          <div className="d-inline-block">
            <Metric
              {...{ value: data.expected_next_7_days.upper_bound }}
              size={"md"}
            />
          </div>
        </div>

        {/* Chart */}
        <div className="col-12 mt-4">
          <ResponsiveContainer height={300} width="100%">
            <ComposedChart
              width={150}
              height={320}
              data={data.data}
              margin={{
                top: 0,
                right: 0,
                left: -38,
                bottom: 0,
              }}
            >
              <Tooltip
                cursor={{ fill: "#eee", opacity: 0.5 }}
                content={
                  <StandardTooltip
                    render={({ data }) => {
                      let payload = data(this.props);
                      if (payload !== null) {
                        // always get the first element
                        payload = payload[0];
                        return (
                          <div className="standard-tooltip">
                            <Fragment>
                              {/* tooltip header */}
                              <header className="standard-tooltip__header">
                                <span className="standard-tooltip__key-header">
                                  Expected for
                                </span>
                                <span className="standard-tooltip__value-header">
                                  {payload.payload.date}
                                </span>
                              </header>

                              {/* Free Trial Ending */}
                              <main className="standard-tooltip__main">
                                <div className="standard-tooltip__item">
                                  <span className="standard-tooltip__key">
                                    <span
                                      className="standard-tooltip__icon"
                                      style={{ background: "#FA6E57" }}
                                    ></span>
                                    Free Trial Ending
                                  </span>
                                  <span className="standard-tooltip__value">
                                    {selectFormat(
                                      "number",
                                      payload.payload.expirations
                                    )}
                                  </span>
                                </div>

                                {/* Prediction */}
                                <div className="standard-tooltip__item">
                                  <span className="standard-tooltip__key">
                                    <span
                                      className="standard-tooltip__icon"
                                      style={{ background: "#868e96" }}
                                    ></span>
                                    Predicted Conversion
                                  </span>
                                  <span className="standard-tooltip__value">
                                    {selectFormat(
                                      "number",
                                      payload.payload.expected_conversions
                                    )}
                                  </span>
                                </div>
                              </main>
                            </Fragment>
                          </div>
                        );
                      }
                    }}
                  />
                }
              />
              <defs>
                <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#FAA461" stopOpacity={1} />
                  <stop offset="95%" stopColor="#FC6D52" stopOpacity={1} />
                </linearGradient>
              </defs>

              <Bar dataKey="expirations" fillOpacity={1} fill="url(#colorUv)" />

              <XAxis
                dataKey="date"
                axisLine={false}
                tickLine={true}
                tick={{
                  strokeWidth: 0,
                  fill: "#25263F",
                }}
              />

              <YAxis
                axisLine={false}
                tickLine={false}
                tickFormatter={(d) => selectFormat("number", d)}
                tick={<CustomizedYAxisTick />}
              />
              <Line dataKey="expected_conversions" stroke="#868e96" />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  }
}

export default FreeTrialConversionPrediction;
